import { useState, memo } from "react";
import Grid from "@mui/material/Grid";
import { useGridApiContext } from "@mui/x-data-grid-pro";
import Button from "@mui/material/Button";
import dayjs from "dayjs";
import ButtonGroup from "@mui/material/ButtonGroup";
import ModelAutoComplete from "../../actprep-ui/components/ModelAutoComplete";
import { DatePicker } from "@mui/x-date-pickers-pro";
import { showSuccessSnackbar } from "../../actprep-ui/utils/feedback";
import Alert from "@mui/material/Alert";

const ProgramWeekDetails = memo(function ({
  row,
  updateWeek,
  validateStartDate,
}) {
  const [formData, setFormData] = useState({
    start_date: row.start_date,
    program_week: row.program_week
      ? {
          uuid: row.program_week.uuid,
          label: row.program_week.title,
        }
      : null,
  });
  const gridApi = useGridApiContext();
  const handleClose = () => {
    gridApi.current.toggleDetailPanel(row.id);
  };
  const [error, setError] = useState(null);
  const handleSubmit = () => {
    if (!validateStartDate(formData.start_date, row.id)) {
      setError(
        "The new start date cannot be within 7 days of an existing week."
      );
      return;
    }
    setError(null);
    updateWeek({
      start_date: formData.start_date,
      program_week: formData.program_week
        ? {
            title: formData.program_week.label,
            uuid: formData.program_week.uuid,
          }
        : null,
    });
    showSuccessSnackbar("Week updated!");
    gridApi.current.toggleDetailPanel(row.id);
  };
  return (
    <Grid
      container
      gap={1}
      sx={{
        padding: "1rem",
      }}
    >
      <Grid size={5}>
        <ModelAutoComplete
          modelName={"ProgramWeek"}
          label={"New Program Week"}
          value={formData.program_week}
          setValue={(newValue) =>
            setFormData((formData) => ({
              ...formData,
              program_week: newValue,
            }))
          }
        />
      </Grid>
      <Grid size={5}>
        <DatePicker
          label="Start Date"
          slotProps={{
            textField: { variant: "standard", fullWidth: true },
          }}
          value={dayjs(formData.start_date)}
          onChange={(newValue) =>
            setFormData((formData) => ({
              ...formData,
              start_date: newValue.toDate(),
            }))
          }
        />
      </Grid>
      <Grid size={12}>
        <ButtonGroup>
          <Button onClick={handleClose}>Close</Button>
          <Button onClick={handleSubmit}>Save</Button>
        </ButtonGroup>
      </Grid>
      {error && (
        <Grid size={12}>
          <Alert severity="error" onClose={() => setError(null)}>
            {error}
          </Alert>
        </Grid>
      )}
    </Grid>
  );
});

export default ProgramWeekDetails;
